import React, { useState, useEffect } from 'react';
import allTeams from '../../data/teams'; // Adjust the import path as necessary
import { Link } from 'react-router-dom';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import apiUrl from '../../config'; 

ChartJS.register(ArcElement, Tooltip, Legend);
const TeamStanding = ({ selectedTeam, totalPoints }) => {

    const [loading, setLoading] = useState(true);
    const [divisionRank, setDivisionRank] = useState(0);
    const [conferenceRank, setConferenceRank] = useState(0);
    const [leagueRank, setLeagueRank] = useState(0);
    const [team, setTeam] = useState({});
    const [wildcardSequence, setWildcardSequence] = useState(0);

    const fetchTeamStats = async (teamId) => {
        const data = await fetch(`${apiUrl}/api/teamstanding`).then(r => r.json());
        setTeam(data.standings.find(t => t.teamAbbrev.default === selectedTeam.triCode));
    }

    useEffect(() => {
        fetchTeamStats(selectedTeam.id);
    }, [selectedTeam]);


    useEffect(() => {
        setDivisionRank(team.divisionSequence);
        setConferenceRank(team.conferenceSequence);
        setLeagueRank(team.leagueSequence);
        setWildcardSequence(team.wildcardSequence+1);
    }, [team]);

    const winPercentage = team.wins / (team.wins + team.losses + team.otLosses); // Calculate win percentage
    const lossPercentage = 1 - winPercentage;

    const chartData = {
        labels: ['Wins (%)', 'Losses (%)'], // Wins first, Losses second
        datasets: [
            {
                data: [winPercentage * 100, lossPercentage * 100], // Wins first, Losses second
                backgroundColor: ['#FFD700', '#191919'], // Wins green, Losses red
                hoverBackgroundColor: ['#FFD700', '#191919'], // Adjust hover colors
                borderWidth: 0,
            },
        ],
    };

    const chartOptions = {
        rotation: 180, // Start at 9 o'clock position
        plugins: {
            legend: {
                display: false,
                position: 'bottom', // Position the legend below the chart
                labels: {
                    font: {
                        size: 8, // Set font size for legend labels
                    },
                    color: '#fff', // Set font color for legend labels
                    usePointStyle: true,       // ✅ Use circular markers
                    pointStyle: 'circle',      // ✅ Specify point style (optional)
                    boxWidth: 10,  
                },
            },
        },
    };

    return (
        <div className='teamStanding'>
            <h2>Team Standing</h2>
            <div className='teamStandingContent'>
                <div className='standingItem'>
                    <h3>{divisionRank}th in Division</h3>
                    <h3>{conferenceRank}th in Conference</h3>
                    <h3>{leagueRank}th in League</h3>
                    <h3>{team.points}pts/{team.gamesPlayed*2} Pts max</h3>
                    <h3>{winPercentage.toFixed(3)}% of Win</h3>
                    <div style={{ width: '60px', height: '60px' }}>
                    <Doughnut data={chartData} options={chartOptions} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeamStanding;
